export default __webpack_public_path__ + "static/media/item3.39d14a88.png";